<template>
	<div>
		<!-- ALERT MESSAGE STARTS -->
		<transition name="fade">
			<div
				class="alert alertmessage"
				:class="{
					'alert-warning': !alert.isSuccess,
					'alert-success': alert.isSuccess,
				}"
				v-if="alert.showAlert"
			>
				<strong>{{ alert.isSuccess ? "Success" : "Error" }}!</strong>

				<br /><br />
				<p v-for="message in alert.alertMessage">♢ {{ message }}</p>
			</div>
		</transition>
		<!-- ALERT MESSAGE ENDS -->

		
		<JanjiDatengModal 
			v-if="modal.showJanjiDateng && !mobile && userShowPending"
			@closeModal="modal.showJanjiDateng = false"
		/>


		<component :is="currentComponent"> </component>
	</div>
</template>

<script>
import PageOptions from "@/Options/PageOptions.js";
import JanjiDatengModal from './janjiDatengModal.vue'

/*
  Import all parent components to this file.
*/

import Home from "./Dashboard/Home.vue";
import About from "./Dashboard/About.vue";

import Welcome from "./Dashboard/Welcome";

//[SPECIAL] User Color
import WorkOrderListing from "./Dashboard/UserColor/WorkOrderListing";
import ColorDetail from "./Dashboard/UserColor/ColorDetail";

//Home Page
import Homepage from "./Dashboard/Homepage/Homepage";

//Work Order
import WorkOrderForm from "./Dashboard/WorkOrderForm/workOrderForm";
import WorkOrderFormNew from "./Dashboard/WorkOrderForm/v2/newWorkOrderForm";
// import WorkOrderDetail from "./Dashboard/WorkOrderForm/workOrderDetail";
import exitCheck from "./Dashboard/WorkOrderForm/v2/exitConditionCheck";
import EditWorkOrder from "./Dashboard/WorkOrderForm/editWorkOrder";
import InsertCarData from "./Dashboard/WorkOrderForm/InsertCarData";
import WorkOrderFormStep from "./Dashboard/WorkOrderForm/workOrderStep";
import InsertCarImage from './Dashboard/WorkOrderForm/v2/children/insertCarImage.vue'
import Scanner from './Dashboard/WorkOrderForm/Scanner.vue'
//V2
// import WorkOrderDetailV2 from './Dashboard/WorkOrderForm/v2/workOrderDetail';
import WorkOrderDetailV2 from './Dashboard/WorkOrderForm/v2/workOrderDetailNew';
import exitCheckV2 from './Dashboard/WorkOrderForm/v2/exitConditionCheck.vue';

//CSO
import CSOExitPermit from "./Dashboard/CSO/ExitPermit/exitPermit";
import CSOCustomerQuotationView from "./Dashboard/CSO/CustomerQuotation/customerQuotationView";
import CSOCustomerQuotationCreate from "./Dashboard/CSO/CustomerQuotation/customerQuotationCreate";
import CSOCustomerQuotationCreateV2 from "./Dashboard/CSO/CustomerQuotation/customerQuotationCreateV2";
import CSOMasterColor from "./Dashboard/CSO/MasterData/color";
import CSOMasterBrandAndType from "./Dashboard/CSO/MasterData/BrandAndType/brandAndType";
import CSOMasterCustomer from "./Dashboard/CSO/MasterData/Customer/customer";
import CSOMasterCustomerCar from "./Dashboard/CSO/MasterData/CustomerCar/customerCar";
import CSOMasterLaborer from "./Dashboard/CSO/MasterData/Laborer/laborer";
import CSOMasterSupplier from "./Dashboard/CSO/MasterData/Supplier/supplier";
import CSOInsurancePolicy from "./Dashboard/CSO/InsurancePolicy/InsurancePolicy";
import CSOCustomerQuotationEdit from "./Dashboard/CSO/CustomerQuotation/customerQuotationEditV2";
import CSOMasterCatBrand from "./Dashboard/CSO/MasterData/CatBrand/CatBrand.vue";
import CSOMasterAddBrandAndType from './Dashboard/CSO/MasterData/BrandAndType/addBrandAndType.vue'

//Estimator
import EstimatorMasterInsurance from "./Dashboard/Estimator/MasterInsurance/MasterInsurance";
import EstimatorInsurancePriceList from "./Dashboard/Estimator/MasterInsurance/InsurancePriceList";
import EstimatorList from "./Dashboard/Estimator/EstimatorApplication/EstimatorList";
import EstimatorApplication from "./Dashboard/Estimator/EstimatorApplication/EstimatorApplicationV2";
import EstimatorSparepart from "./Dashboard/Estimator/EstimatorSparepart/estimatorSparepart";
import EstimatorSparepartDetail from "./Dashboard/Estimator/EstimatorSparepart/estimatorSparepartDetail";
import ComplainWorkOrder from "./Dashboard/Estimator/ComplainWorkOrder/Complain";
import ComplainView from "./Dashboard/Estimator/ComplainWorkOrder/ComplainWorkOrder";
import EstimatorAddSparepart from './Dashboard/Estimator/EstimatorApplication/children/newSparepartPOS.vue'
import EstimatorParts from './Dashboard/Estimator/EstimatorParts/EstimatorParts.vue'

//Inventory
import MasterSparepart from "./Dashboard/Inventory/MasterSparepart/MasterSparepart";
// import InventoryUsage from "./Dashboard/Inventory/InventoryUsage/InventoryUsage";
import InventoryUsage from "./Dashboard/Inventory/InventoryUsage/NewInventoryUsage";
import PurchaseInventory from "./Dashboard/Inventory/PurchaseInventory/PurchaseInventory";
import PurchaseInventoryList from "./Dashboard/Inventory/PurchaseInventory/WOList";
import SalvageParts from "./Dashboard/Inventory/SalvageParts/SalvageParts";
import SalvagePartsDetail from "./Dashboard/Inventory/SalvageParts/salvageDetails";
import PurchaseStock from "./Dashboard/Inventory/PurchaseStock/purchaseStock";
import PendingSparepart from './Dashboard/Inventory/PendingSparepart/PendingSparepart';

//Report
import ReportInsurance from "./Dashboard/Report/InsuranceReport/InsuranceReport";
import PettyCash from "./Dashboard/Report/PettyCash/PettyCash";
import OwnRisk from "./Dashboard/Report/OwnRisk/OwnRisk";
import ReportInventoryUsage from "./Dashboard/Report/InventoryUsage/InventoryUsage";
import POSparepart from "./Dashboard/Report/POSparepart/POSparepart";
import ReportRevenue from "./Dashboard/Report/RevenueReport/RevenueReport";
import OutstandingEstimation from "./Dashboard/Report/OutstandingEstimation/OutstandingEstimation";
import OutstandingEstimationSparepart from "./Dashboard/Report/OutstandingEstimationSparepart/OutstandingEstimationSparepart";
import PriceEvaluation from "./Dashboard/Report/PriceEvaluation/PriceEvaluation";
import SupplierReport from "./Dashboard/Report/SupplierReport/SupplierReport";
import IdleReport from "./Dashboard/Report/IdleReport/IdleReport";
import ReportInsurancePolicyExpiry from "./Dashboard/Report/PolicyExpiry/PolicyExpiry";
import SupplierVoucher from "./Dashboard/Report/SupplierVoucher/SupplierVoucher";
import SupplierVoucherDetails from "./Dashboard/Report/SupplierVoucher/children/SupplierVoucherDetails";
import EstimationSameDay from './Dashboard/Report/EstimationSameDay/EstimationSameDay.vue'
import NotBeingWorkedOn from './Dashboard/Report/NotBeingWorkedOn/NotBeingWorkedOn.vue'

//Finance
import FinanceKasKecil from "./Dashboard/Finance/KasKecil/KasKecil";
import FinanceKasBesar from "./Dashboard/Finance/KasBesar/KasBesar";
import FinancePaycheck from "./Dashboard/Finance/Paycheck/Paycheck";
import FinancePaycheckMonthly from "./Dashboard/Finance/Paycheck/PaycheckMonthly";
import FinanceWorkOrderPayment from "./Dashboard/Finance/PembayaranWorkOrder/PembayaranWorkOrder";
import FinanceIncomeStatement from "./Dashboard/Finance/IncomeStatement/IncomeStatement";
import FinanceBalanceSheet from "./Dashboard/Finance/BalanceSheet/BalanceSheet";
import FinanceJasaBorongan from "./Dashboard/Finance/JasaBorongan/JasaBorongan";
import FinanceKwitansiHistory from './Dashboard/Finance/KwitansiHistory/KwitansiHistory.vue'
import FinancePayment from './Dashboard/Finance/Payment/Payment.vue'
import FinanceAccountTransaction from './Dashboard/Finance/AccountTransaction/AccountTransaction.vue'
import SupplierVoucherCreate from './Dashboard/Report/SupplierVoucher/children/createVoucher.vue'
import FinanceDownPayment from './Dashboard/Finance/DownPayment/DownPayment.vue'

// Human Resouce
import HumanResourceKpi from "./Dashboard/HR/KPI/KPI";
import HumanResourceAttendance from "./Dashboard/HR/Attendance/Attendance";

//Setting
import UserManagement from "./Dashboard/Setting/UserManagement/UserManagement";
import RoleManagement from "./Dashboard/Setting/RoleManagement/RoleManagement";
import CompanyDetail from "./Dashboard/Setting/CompanyDetail/companyDetail";
import ChecklistItems from "./Dashboard/Setting/ChecklistItems/ChecklistItems";
import PriceListOption from "./Dashboard/Setting/PriceListOptions/PriceListOptions";
import CSOSupplyApply from './Dashboard/Setting/SupplyApply/SupplyApply.vue'
import PartServices from "./Dashboard/Setting/PartServices/PartServices";
import AdminAuthorization from "./Dashboard/Setting/AdminAuthorization/AdminAuthorization";

export default {
	metaInfo: {
		title: "Smart Claim Systems",
		titleTemplate: "%s",
		htmlAttrs: {
			lang: "en",
			amp: true,
		},
	},
	components: {
		Home,
		About,
		JanjiDatengModal,

		Welcome,

		//[SPECIAL] User Color
		WorkOrderListing,
		ColorDetail,

		//Homepage
		Homepage,

		//Work Order
		WorkOrderForm,
		WorkOrderFormStep,
		WorkOrderFormNew,
		// WorkOrderDetail,
		exitCheck,
		EditWorkOrder,
		InsertCarData,
		WorkOrderDetailV2,
		exitCheckV2,
		InsertCarImage,
		Scanner,

		//CSO
		CSOExitPermit,
		CSOCustomerQuotationView,
		CSOCustomerQuotationCreate,
		CSOCustomerQuotationEdit,
		CSOMasterColor,
		CSOMasterBrandAndType,
		CSOMasterCustomer,
		CSOMasterCustomerCar,
		CSOMasterLaborer,
		CSOMasterSupplier,
		CSOInsurancePolicy,
		CSOMasterCatBrand,
		CSOMasterAddBrandAndType,
		CSOCustomerQuotationCreateV2,
		CSOSupplyApply,

		//Estimator
		EstimatorMasterInsurance,
		EstimatorInsurancePriceList,
		EstimatorList,
		EstimatorApplication,
		EstimatorSparepart,
		EstimatorSparepartDetail,
		ComplainWorkOrder,
		ComplainView,
		EstimatorAddSparepart,
		EstimatorParts,

		//Inventory
		MasterSparepart,
		InventoryUsage,
		PurchaseInventory,
		PurchaseInventoryList,
		SalvageParts,
		SalvagePartsDetail,
		PurchaseStock,
		PendingSparepart,

		//Report
		ReportInsurance,
		PettyCash,
		OwnRisk,
		ReportInventoryUsage,
		POSparepart,
		ReportRevenue,
		OutstandingEstimation,
		OutstandingEstimationSparepart,
		PriceEvaluation,
		SupplierReport,
		IdleReport,
		ReportInsurancePolicyExpiry,
		SupplierVoucher,
		SupplierVoucherDetails,
		EstimationSameDay,
		NotBeingWorkedOn,

		//Finance
		FinanceKasKecil,
		FinanceKasBesar,
		FinancePaycheck,
		FinancePaycheckMonthly,
		FinanceWorkOrderPayment,
		FinanceIncomeStatement,
		FinanceBalanceSheet,
		FinanceJasaBorongan,
        FinanceKwitansiHistory,
		FinancePayment,
		FinanceAccountTransaction,
		SupplierVoucherCreate,
		FinanceDownPayment,

		//Human Resource
		HumanResourceKpi,
		HumanResourceAttendance,

		//Setting
		UserManagement,
		RoleManagement,
		CompanyDetail,
		ChecklistItems,
		PriceListOption,
		PartServices,
		AdminAuthorization,
	},
	data() {
		return {
			pageOptions: PageOptions,
			currentComponent: "",
			alert: this.$store.getters.getAlertStatus,
			alertDuration: 5000, //in ms,
			modal : {
				showJanjiDateng : null
			},
			mobile : this.isMobile(),
			userShowPending : false
		};
	},
	created() {
		this.pageOptions.pageEmpty = false;
	},
	mounted() {
		let user = this.$store.state.userData.userData

		if(user.role.length == 0) {
			this.userShowPending = true
		}
		else if (user.role.find(x => x.name == 'Gudang')) {
			this.userShowPending = true
		}

		// console.log(this.mobile, this.userShowPending)


		this.modal.showJanjiDateng = this.$store.state.showPendingBarang
		this.currentComponent = this.$route.name;
		this.checkAlert();
		// alert(this.modal.showJanjiDateng)
	},
	watch: {
		"$store.getters.getAlertStatus": function() {
			this.alert = this.$store.getters.getAlertStatus;
			this.checkAlert();
		},
		'modal.showJanjiDateng' : function () {
			// this.$store.state.showPendingBarang = false
			this.$set(this.$store.state , 'showPendingBarang' , false)
			// alert(this.$store.state.showPendingBarang)
		}
	},
	beforeRouteLeave(to, from, next) {
		PageOptions.pageEmpty = true;
		next();
	},
	methods: {
		checkAlert() {
			setTimeout(() => {
				if (this.alert.showAlert)
					this.$store.dispatch("setShowAlert", false);
			}, this.alertDuration);
		},
	},
};
</script>

<style>
.outerBox {
	padding: 0 20px;
}
.innerBox {
	padding: 1.5rem;
	border: 1px solid #eeeeee;
	border-radius: 5px;
	background-color: white;
	box-shadow: 2px 2px 5px #e0e0e0;
}

.align-middle {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

/* MODAL STARTS */
.modal-mask {
	position: fixed;
	z-index: 1020;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	width: 100%;
	margin: 0px auto;
	padding: 20px 30px;
	background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 20px 0;
}

.modal-default-button {
	float: right;
}

/*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
	margin: 0;
	max-height: 90vh;
	overflow-x: auto;
	overflow-y: auto;
}

.modal-body .moduleLine {
	margin-bottom: 0vh;
}

.modal-body .moduleLine a {
	text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
	background-color: #e0e0e0;
	transition: background-color 0.7s ease;
	color: #212121;
	transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
	border: 1px solid #bdbdbd;
	border-radius: 20px;
	padding: 20px 0;
	color: black;
	margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
	font-size: 5vh;
}

h3.modalHeadline {
	margin: 0 0 20px 0;
	font-weight: bold;
	text-align: center;
}
/* MODAL ENDS */

/* ALERT MESSAGE STARTS */
.alertmessage {
	position: fixed;
	top: 10%;
	left: 50%;
	transform: translate(-50%, 0);
	z-index: 9999;
	width: 300px;
	text-align: center;
}
.alertmessage strong {
	font-size: 150%;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* ALERT MESSAGE ENDS */

.btn-outline-primary {
	color: #348fe2 !important;
	border-color: #348fe2 !important;
}
.btn-outline-primary:hover {
	color: white !important;
	background-color: #348fe2 !important;
}
</style>

<style scoped></style>
